import React from 'react';

import ServiceAreaCard from '../../common/cards/service-area-card/ServiceAreaCard';
import { Cell, Grid } from '../../layout';

const IncomeAreasSection = ({
  budget,
  changeCouncilCategoryAction,
  status,
  isSummary = false,
}) => {

  const cardStatus = status ? status : budget.council;
  const keys = [1];

  return (
    <div className="l-section l-section--grey income-areas-section-main-container">
      <Grid>
        {
          keys.map(key => (
            <Cell size={{ desktop: '12', tablet: '12', phone: '12' }} key={key}>
              <ServiceAreaCard
                status={cardStatus[`council_${key}`]}
                k={1}
                name={budget.council[`council_${key}_name`]}
                value={budget.council[`council_${key}_val`]}
                info={budget.council[`council_${key}_info`]}
                step={budget.council[`council_${key}_val`] / 10}
                isSummary={isSummary}
                onChange={(v) => changeCouncilCategoryAction(`council_${key}`, v)}
              />
            </Cell>
          ))
        }
      </Grid>
    </div>
  )
}

export default IncomeAreasSection;



// WEBPACK FOOTER //
// ./src/components/sections/income-areas-section/IncomeAreasSection.jsx